import { PART_TYPES, TRANSFORMATION_TYPES, SHIRT_COLOR_TYPES } from './enums'

export const PART_ACTIONS = Object.freeze({
  [PART_TYPES.EYES]: [
    PART_TYPES.EYE_LINER,
    TRANSFORMATION_TYPES.SCALE,
    TRANSFORMATION_TYPES.ROTATION,
    TRANSFORMATION_TYPES.SPACING,
    TRANSFORMATION_TYPES.VERTICAL_OFFSET,
  ],
  [PART_TYPES.EYEBROWS]: [
    TRANSFORMATION_TYPES.SCALE,
    TRANSFORMATION_TYPES.ROTATION,
    TRANSFORMATION_TYPES.SPACING,
    TRANSFORMATION_TYPES.VERTICAL_OFFSET,
  ],
  [PART_TYPES.NOSE]: [TRANSFORMATION_TYPES.SCALE, TRANSFORMATION_TYPES.VERTICAL_OFFSET],
  [PART_TYPES.MOUTH]: [TRANSFORMATION_TYPES.SCALE, TRANSFORMATION_TYPES.VERTICAL_OFFSET],
  [PART_TYPES.FACIAL_HAIR]: [TRANSFORMATION_TYPES.VERTICAL_OFFSET],
  [PART_TYPES.GLASSES]: [TRANSFORMATION_TYPES.SCALE, TRANSFORMATION_TYPES.VERTICAL_OFFSET],
  [PART_TYPES.SHIRT]: [SHIRT_COLOR_TYPES.MAIN, SHIRT_COLOR_TYPES.SECOND],
})

export const MIN = 'MIN'
export const MAX = 'MAX'
export const TRANSFORMATION_SLIDER_VALUES = Object.freeze({
  [TRANSFORMATION_TYPES.SCALE]: {
    [MIN]: 0.5,
    [MAX]: 1.5,
  },
  [TRANSFORMATION_TYPES.ROTATION]: {
    [MIN]: -45,
    [MAX]: 45,
  },
  [TRANSFORMATION_TYPES.SPACING]: {
    [MIN]: -6,
    [MAX]: 6,
  },
  [TRANSFORMATION_TYPES.VERTICAL_OFFSET]: {
    [MIN]: -10,
    [MAX]: 5,
  },
})

export const MALE_HAIR_IDS = [
  100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
  127, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 87, 83, 84, 85, 86, 87, 88, 89,
  90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
]
